module.exports = __webpack_public_path__ + "img/denmark-liver-cancer-female.3db6c0eb.png";